/**
 * @author - steves165
 */

(function() {
    'use strict';

    angular.module('vhols')

    /**
     * Creates universal_variable for Core Metrics and populates it with attribute values.
     */
        .directive('universalVariables', function() {
            return {
                replace: false,
                link: function($scope, $element, $attr) {
                    window.universal_variable = JSON.parse($attr.variables.replace(/\'/g, '"'));

                }
            };
        })

		.directive('imageLoader', function() {
            return {
                scope: {
                    imageLoader: '@',
                    mobileImage: '@',
                    device: '=',
                    count: '@'
                },
                link: function($scope, $element) {
                    var desktopImage = JSON.parse($scope.imageLoader);
                    var mobileImage = JSON.parse(($scope.mobileImage && $scope.mobileImage !== '') ? $scope.mobileImage : $scope.imageLoader);
                    var desktopScreen = window.innerWidth >= 768;

                    var imageToLoad = '/.imaging/' + $scope.device + '/dam/' + (desktopScreen ? desktopImage.link : mobileImage.link);

                    $element.attr('src', imageToLoad);

                    $element.attr('alt', desktopScreen ? desktopImage.alt : mobileImage.alt);

                }
            };
        })

		.directive('countdownClockFix', function () {
			return {
				link: function ($scope, $element, $attrs) {

					function staticise() {
						var photoCarouselBottom = document.getElementById('homepage-carousel-container').getBoundingClientRect().bottom;
						var offset = $attrs.offset ? parseInt($attrs.offset, 10) : 0;

						if (photoCarouselBottom - offset > window.innerHeight) {
							$element.addClass('clock-static');
						} else {
							$element.removeClass('clock-static');
						}
					}

					$scope.$on('countdownClockScroll', function(_, scrollEvent) {
						staticise();
					});

					setTimeout(staticise, 500);
				}
			};
		})

		.directive('bannerImageLoader', function() {
            return {
                scope: {
                    bannerImageLoader: '@',
                    mobileImage: '@'
                },
                link: function($scope, $element) {
					var isMobile = window.innerWidth < vhols.mobileScreenWidth;

					$scope.mobileImage = $scope.mobileImage ? $scope.mobileImage : $scope.bannerImageLoader;
                    var imageToLoad = '/dam/' + (isMobile ? $scope.mobileImage : $scope.bannerImageLoader);

                    $element.attr('style', 'background-image: url("' + imageToLoad + '")');
                }
            };
        })

		.directive('checkBackgroundClip', function() {
			function checkBackgroundClip($element) {
				var supported = false;

				if (typeof CSS !== 'undefined' && CSS.supports) {
					supported = CSS.supports('background-clip', 'text') || CSS.supports('-webkit-background-clip', 'text');
				}

				return supported;
			}

			return {
				link: function($scope, $element) {
					if (typeof $scope.backgroundClip === 'undefined') {
						$scope.backgroundClip = checkBackgroundClip($element[0]);
					}

					if (!$scope.backgroundClip) {
						$element.addClass('no-background-clip');
					}
				}
			};
		})

        .directive('mobileSticky', ['$window', function($window) {
            return {
                link: function($scope, $element, $attr) {
                    var stickyTop = $element[0].offsetTop,
                        $windowEl = angular.element($window),
                        $body = angular.element($window.document.body),
                        $buttonTitle = $element.find('span'),
                        scrollY = 0,
                        unWatch;

                    $windowEl.on('scroll', function() {
                        var isButtonSticky = $window.scrollY > stickyTop,
                            title = isButtonSticky ? $attr.mobileSticky : $scope.searchBarCollapsedTitle || 'Find Holidays';

                        $element.toggleClass('mobile-sticky-panel', isButtonSticky);
                        if (!$scope.toggleSearch) {
                            $buttonTitle.html(title);
                        }
                    });

                    unWatch = $scope.$watch('toggleSearch', function(value) {
                        if (value) {
                            scrollY = $window.scrollY;
                            $body.attr('style', 'top:'+ (-scrollY) +'px;');
                            $body.addClass('open-sticky-panel');
                        }
                        else {
                            $body.removeClass('open-sticky-panel');
                            $window.scroll(0, scrollY);
                            $body.removeAttr('style');
                        }
                    });

                    $scope.$on('$destroy', function() {
                        $windowEl.off('scroll');
                        unWatch();
                    });
                }
            };
        }]);
})();
